import React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IAmbienceMenuState } from "../IAmbienceMenuState";

export function ToggleAmbience({ isAmbienceOn }: { isAmbienceOn: boolean }) {
    return (
        <span
            style={{
                color: isAmbienceOn ? `yellowgreen` : `inherit`,
            }}
        >
            <IconWithText
                iconSuffix={EGlyphicon.cloud}
                whenClicked={() => {
                    isAmbienceOn ? Ambience.Stop() : Ambience.StartNextAmbience();

                    State.ReadClass<IAmbienceMenuState>(
                        ESharedComponent.AmbienceMenu
                    ).setState({
                        currentFileInfo: undefined,
                    });
                }}
                displayAsBlock
                customStyle={{ margin: 0 }}
            >
                {isAmbienceOn ? `Ambience ON` : `Ambience OFF`}
            </IconWithText>
        </span>
    );
}
